export const styles = (theme) => ({
  title: {
    fontWeight: 500,
    lineHeight: "normal",
    color: "#000000",
    marginBottom: 20,
    [theme.breakpoints.up("lg")]: {
      fontSize: 34,
    },
    [theme.breakpoints.between("sm", "md")]: {
      fontSize: "1.75rem",
    },
    [theme.breakpoints.only("xs")]: {
      fontSize: "1.5rem",
    },
  },
  iconButton: {
    padding: 10,
  },
  containerImage: {
    borderRadius: 16,
    height: "172px",
    width: "172px",
    boxShadow:
      "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);",
    backgroundSize: "cover",
    backgroundPosition: "center",
    [theme.breakpoints.only("md")]: {
      height: "150px",
      width: "150px",
    },
    [theme.breakpoints.down("sm")]: {
      height: "130px",
      width: "130px",
      marginBottom: 14,
    },
  },
  rootPaper: {
    [theme.breakpoints.up("xl")]: {
      width: "93%",
      padding: "2.453% 3.189%",
    },
    [theme.breakpoints.between("lg", "xl")]: {
      width: "93%",
      padding: "2.453% 3.189%",
    },
    [theme.breakpoints.between("md", "lg")]: {
      width: "93%",
      padding: "2.453% 3.189%",
    },
    [theme.breakpoints.only("sm")]: {
      width: "94%",
      padding: "2.453% 3.189%",
    },
    "@media screen and (max-width: 600px) ": {
      padding: "2%",
    },
  },
  container: {
    flexWrap: "nowrap",
    "@media screen and (max-width: 600px) ": {
      justifyContent: "center",
    },
  },
  containerOne: {
    marginBottom: theme.spacing(3),
  },
  name: {
    lineHeight: 1.2,
    fontWeight: 500,
    marginBottom: theme.spacing(1.5),
    fontSize: "1rem",
  },
  code: {
    fontSize: "0.875rem",
    marginBottom: theme.spacing(3.5),
  },
  date: {
    fontWeight: "bold",
    color: "#e60000",
  },
  firstDayBottom: {
    marginBottom: theme.spacing(2),
  },
  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    [theme.breakpoints.up("xl")]: {
      marginLeft: 32,
    },
    [theme.breakpoints.between("lg", "xl")]: {
      marginLeft: 32,
    },
    [theme.breakpoints.between("sm", "md")]: {
      marginLeft: 26,
    },
    "@media screen and (max-width: 600px)": {
      marginLeft: 24,
    },
  },
  containerOrder: {
    height: "100%",
    margin: 0,
    boxSizing: "border-box",
  },
  borderNoneLeft: {
    borderLeft: "none",
    borderRadius: `0 ${theme.spacing(2)}px ${theme.spacing(2)}px 0`,
  },
  borderNoneRight: {
    borderRight: "none",
    borderRadius: `${theme.spacing(2)}px 0 0 ${theme.spacing(2)}px`,
  },
  border: {
    borderLeft: "none",
    borderRight: "none",
    position: "relative",
    zIndex: 1,
    "&:before": {
      position: "absolute",
      content: "''",
      top: 0,
      left: 0,
      height: "50%",
      width: 1,
      borderLeft: "2px groove threedface",
      transform: "translate(-50%, 50%)",
    },
    "&:after": {
      position: "absolute",
      content: "''",
      top: 0,
      right: 0,
      height: "50%",
      width: 1,
      borderLeft: "2px groove threedface",
      transform: "translate(-50%, 50%)",
    },
  },
  containerOrderContent: {
    fontWeight: 500,
    color: "#292f48",
    fontSize: "1.3rem",
    display: "flex",
    height: `calc(100% - ${theme.spacing(3)}px)`,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 70,
    padding: `0 ${theme.spacing(2)}px`,
    [theme.breakpoints.down("md")]: {
      fontSize: "1rem",
    },
  },

  textCenter: {
    fontWeight: 500,
    color: "#292f48",
    textAlign: "center",
    fontSize: "0.9rem",
    lineHeight: "1.2rem",
    padding: `0 ${theme.spacing(1)}px`,
  },
  averageValueOrder: {
    fontWeight: "inherit",
    fontSize: "inherit",
  },
  orderValueOrder: {
    fontWeight: "inherit",
    fontSize: "inherit",
  },
  currencyOrder: {
    fontWeight: "inherit",
    fontSize: "inherit",
  },
  form: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginTop: "3.066%",
    width: "100%",
    marginBottom: "2%",
  },
  label: {
    marginRight: theme.spacing(3.25),
  },
  rootInput: {
    borderRadius: theme.spacing(0.5),
    backgroundColor: "#ffffff",
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    fontSize: "0.875rem",
  },
  rootPaperOrders: {
    overflow: "auto",
    // height: '90%',
    [theme.breakpoints.down("md")]: {
      // height: '95%',
    },
  },
  titleOrders: {
    lineHeight: 1.2,
    marginTop: 20,
    marginBottom: 20,
  },

  table: {
    // minWidth: 700,
  },
  tableCell: {
    color: "inherit",
    fontWeight: "inherit",
  },
  textAlignCenter: {
    textAlign: "center",
  },
});
